import { useState, useEffect } from 'react';
import { BXPOutboundRulesTable } from 'components/tables/BXPOutboundRulesTable';
import {
  fetchBXPOutboundRules,
  BXPOutboundRule
} from 'services/hvaservicecampaign.service';

const BXPOutboundRuleList: React.FC = () => {
  const [outboundRules, setOutboundRules] = useState<BXPOutboundRule[]>([]);
  const loadOutboundRules = async (): Promise<void> => {
    try {
      const fetchedOutboundRules = await fetchBXPOutboundRules();
      setOutboundRules(fetchedOutboundRules);
    } catch (error) {
      console.error('Error loading outbound rules:', error);
    }
  };

  useEffect(() => {
    loadOutboundRules();
  }, []);

  return (
    <div>
      <div className="mb-2">
        <BXPOutboundRulesTable
          outboundRules={outboundRules}
          onOutboundRulesChange={loadOutboundRules}
        />
      </div>
    </div>
  );
};

export default BXPOutboundRuleList;
